// Тихий клиентский счётчик продуктовых событий. track() копит события в буфере,
// flush() отправляет их батчем на POST /events (то, чего серверный audit-log не видит:
// просмотры экранов, тапы). Аналитика НИКОГДА не должна влиять на UI: отказ отправки
// глотаем, ошибок наружу не пробрасываем. Имена событий и ключи props должны совпадать
// с белым списком бэкенда (backend/src/events/routes.ts).
import { endpoints } from '../api/endpoints';

type Props = Record<string, unknown>;
let buf: Array<{ event: string; props?: Props }> = [];
let timer: ReturnType<typeof setTimeout> | null = null;

export function track(event: string, props?: Props): void {
  buf.push({ event, props });
  if (!timer) timer = setTimeout(flush, 10_000);
}

export function flush(): void {
  if (buf.length === 0) return;
  const batch = buf;
  buf = [];
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  void endpoints.sendEvents(batch).catch(() => {
    /* тихо: аналитика не должна влиять на UI */
  });
}

// Перед уходом со страницы/сворачиванием — досылаем накопленное (мобильный кейс: вкладку
// часто не «закрывают», а прячут). guard на document — модуль грузится и в тестовом окружении.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
}

// pagehide надёжнее visibilitychange при закрытии webview (свайп в Telegram Mini App / iOS PWA):
// часто это единственное событие при выгрузке. Слушаем на window (отдельный guard).
if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => flush());
}
